module.exports = __webpack_public_path__ + "static/greenday-89bd0005c3bdab29724e45fb5f2396c5.png";